define.alias("ember-power-select/components/power-select/options", "settings/components/power-select/options");